function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null);

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

var SvgBeach = function SvgBeach(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#90A4AE"
    },
    d: "M255.23,414.029l88.641-222.402c3.709-9.306,14.26-13.844,23.566-10.135 c9.306,3.709,13.844,14.26,10.135,23.566l-84.653,212.396L255.23,414.029z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFF9C5"
    },
    d: "M290.171,220.482c0.009-0.021,0.018-0.042,0.027-0.063c-0.009,0.001-0.018,0.003-0.026,0.004 L290.171,220.482z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.1,
      enableBackground: "new"
    },
    d: "M367.439,181.492c-9.306-3.709-19.857,0.828-23.566,10.135l-23.211,58.237 c5.914,0.945,11.796,2.559,17.587,4.868c5.791,2.308,11.193,5.181,16.121,8.545l23.204-58.218 C381.282,195.751,376.745,185.201,367.439,181.492z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFF9C5"
    },
    d: "M399.536,100.961l-66.884,7.189l-42.481,49.475l0.007,62.783l0.03-0.012 c-0.003,0.007-0.006,0.015-0.01,0.022c18.552-3.445,39.208-1.638,59.202,6.331c19.867,7.918,36.018,20.704,47.109,35.837 l0.194,0.354l34.942-34.596l3.898-86.328L399.536,100.961z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFCA28"
    },
    d: "M461.612,453.139c-24.34-38.907-106.776-67.539-204.726-67.539 c-97.947,0-180.38,28.63-204.723,67.535l13.675,0.004l29.677,19.032l31.205,3.392l21.992-12.706l34.908-12.732l18.733,5.087 l39.853,20.351l26.286-4.24l33.917-12.655l24.59-7.695l31.373,7.695l25.438,16.895l40.701-5.087L461.612,453.139z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.1,
      enableBackground: "new"
    },
    d: "M427.368,469.141l34.245-16.002 c-24.34-38.906-106.776-67.539-204.726-67.539c-22.521,0-44.217,1.517-64.579,4.32C293.35,401.508,377.86,430.567,427.368,469.141z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1EB8E8"
    },
    d: "M508.696,457.316c-24.053-16.313-55.138-16.313-79.191,0c-18.918,12.83-43.365,12.83-62.285,0 c-24.053-16.313-55.138-16.313-79.191,0c-18.918,12.83-43.366,12.83-62.285,0c-24.053-16.313-55.138-16.313-79.191,0 c-18.919,12.83-43.366,12.83-62.285,0c-24.053-16.313-55.138-16.313-79.191,0c-3.442,2.334-4.34,7.017-2.006,10.459 c2.334,3.442,7.018,4.339,10.459,2.006c18.918-12.83,43.366-12.831,62.285,0c24.054,16.312,55.139,16.312,79.191,0 c18.918-12.83,43.366-12.831,62.285,0c24.054,16.312,55.139,16.312,79.191,0c18.918-12.83,43.366-12.831,62.285,0 c12.027,8.156,25.812,12.234,39.596,12.234c13.784,0,27.569-4.078,39.595-12.234c18.918-12.83,43.366-12.83,62.285,0 c3.443,2.335,8.125,1.436,10.459-2.006C513.036,464.334,512.138,459.651,508.696,457.316z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EF495B"
    },
    d: "M290.178,220.409c-11.098-15.259-27.334-28.156-47.327-36.125 c-20.003-7.973-40.671-9.778-59.228-6.327c0,0,90.046-127.161,215.914-76.995c0,0-66.007,17.655-109.365,119.521L290.178,220.409z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EF495B"
    },
    d: "M396.749,262.884c18.552-3.443,39.208-1.636,59.202,6.333c20.003,7.973,36.247,20.878,47.342,36.148 c0,0,22.11-154.238-103.758-204.405c0,0,35.767,58.218-2.831,161.98L396.749,262.884z"
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFCA28"
    },
    cx: 85.695,
    cy: 115.685,
    r: 41.025
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF9800"
    },
    d: "M85.696,60.193c-4.159,0-7.53-3.372-7.53-7.53V37.515c0-4.159,3.372-7.53,7.53-7.53 s7.53,3.372,7.53,7.53v15.148C93.226,56.822,89.854,60.193,85.696,60.193z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF9800"
    },
    d: "M130.255,78.651c-1.927,0-3.854-0.735-5.324-2.206c-2.941-2.941-2.941-7.709,0-10.65l10.711-10.711 c2.941-2.941,7.709-2.941,10.649,0c2.941,2.941,2.941,7.709,0,10.65l-10.711,10.711C134.109,77.916,132.182,78.651,130.255,78.651z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF9800"
    },
    d: "M163.86,123.211h-15.147c-4.159,0-7.53-3.372-7.53-7.53s3.372-7.53,7.53-7.53h15.147 c4.159,0,7.53,3.372,7.53,7.53S168.019,123.211,163.86,123.211z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF9800"
    },
    d: "M140.966,178.482c-1.927,0-3.855-0.735-5.324-2.206l-10.711-10.711 c-2.941-2.941-2.941-7.709,0-10.65c2.941-2.941,7.709-2.941,10.649,0l10.711,10.711c2.941,2.941,2.941,7.709,0,10.65 C144.82,177.746,142.894,178.482,140.966,178.482z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF9800"
    },
    d: "M85.696,201.375c-4.159,0-7.53-3.372-7.53-7.53v-15.148c0-4.159,3.372-7.53,7.53-7.53 s7.53,3.372,7.53,7.53v15.148C93.226,198.005,89.854,201.375,85.696,201.375z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF9800"
    },
    d: "M30.424,178.482c-1.927,0-3.854-0.735-5.324-2.206c-2.941-2.941-2.941-7.709,0-10.65l10.71-10.711 c2.941-2.941,7.709-2.941,10.649,0c2.941,2.941,2.941,7.709,0,10.65l-10.71,10.711C34.279,177.746,32.352,178.482,30.424,178.482z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF9800"
    },
    d: "M22.678,123.211H7.53c-4.159,0-7.53-3.372-7.53-7.53s3.372-7.53,7.53-7.53h15.148 c4.159,0,7.53,3.372,7.53,7.53S26.837,123.211,22.678,123.211z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF9800"
    },
    d: "M41.135,78.651c-1.927,0-3.854-0.735-5.324-2.206L25.1,65.735c-2.941-2.941-2.941-7.709,0-10.65 c2.941-2.941,7.709-2.941,10.649,0l10.71,10.711c2.941,2.941,2.941,7.709,0,10.65C44.99,77.916,43.062,78.651,41.135,78.651z"
  })), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBeach, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/beach.bd810bea.svg";
export { ForwardRef as ReactComponent };